import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { Toast } from 'primereact/toast';

const CustomToast = forwardRef((props, ref: any) => {
  const toast: any = useRef(null);

  useImperativeHandle(ref, () => ({
    show: (message: any) => {
      toast.current.show(message);
    },
  }));

  return <Toast ref={toast} />;
});

export default CustomToast;


